import { render, staticRenderFns } from "./group-detail.vue?vue&type=template&id=cd5e923c&scoped=true&lang=pug"
import script from "./group-detail.vue?vue&type=script&lang=js"
export * from "./group-detail.vue?vue&type=script&lang=js"
import style0 from "./group-detail.vue?vue&type=style&index=0&id=cd5e923c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5e923c",
  null
  
)

export default component.exports